/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		16: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-BrokerChooser","1":"route-SingleBrokerLogin","2":"route-BrokerConnected","3":"route-VerifyingLogin","4":"route-SmallcaseLoader","5":"route-PreConnect","6":"route-PreBrokerChooser","7":"route-Placeholder","8":"route-OrderflowWaiting","9":"route-OrderInQueue","10":"route-LoginFailed","11":"route-LasLoader","12":"route-HoldingsFetch","13":"route-GenericLoader","14":"route-Error","15":"route-EmptyBg"}[chunkId]||chunkId) + ".chunk." + {"0":"29f19","1":"6631e","2":"857c4","3":"67661","4":"b5c65","5":"5f126","6":"eb097","7":"40d32","8":"d5141","9":"0c754","10":"478b7","11":"02042","12":"552d8","13":"23809","14":"e3f10","15":"44f19"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/Fvp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strictUriEncode = __webpack_require__("A2is");
var objectAssign = __webpack_require__("J4Nk");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({ arrayFormat: 'none' }, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subscribers */
/* unused harmony export getCurrentUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Router; });
/* unused harmony export Route */
/* unused harmony export Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* unused harmony default export */ var _unused_webpack_default_export = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/pBF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "23TE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickToContinueContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetClickToContinue; });
function getClickToContinueObj() {
  var returnObj = {
    onClick: undefined,
    promise: undefined
  };

  returnObj.promise = new Promise(function (resolve, reject) {
    returnObj.onClick = function () {
      return resolve();
    };
  });

  return returnObj;
}

var clickToContinueContainer = {
  current: undefined
};

function resetClickToContinue() {
  clickToContinueContainer.current = getClickToContinueObj();
}



/***/ }),

/***/ "49Lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBrokerDisplayNameFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBrokerFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParamsFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBrokerShortNameFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGatewayLoginConsentFromURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("/Fvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);


function getBrokerFromURL() {
  var queryParamsObj = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  var brokerName = queryParamsObj.broker;

  if (brokerName !== undefined) {
    brokerName = brokerName.toLowerCase();
    // Remove leprechaun from broker key, if it is present
    brokerName = brokerName.replace('-leprechaun', '');
  }

  return brokerName;
}

function getBrokerDisplayNameFromURL(brokerMap) {
  var brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (var _iterator = brokerMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var broker = _ref;

      if (broker.broker === brokerKey) {
        return broker.brokerDisplayName;
      }
    }
  }
  return '';
}

function getBrokerShortNameFromURL(brokerMap) {
  var brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (var _iterator2 = brokerMap, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var broker = _ref2;

      if (broker.broker === brokerKey) {
        return broker.brokerShortName;
      }
    }
  }
  return '';
}

function getGatewayLoginConsentFromURL(brokerMap) {
  var brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (var _iterator3 = brokerMap, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var broker = _ref3;

      if (broker.broker === brokerKey) {
        return broker.gatewayLoginConsent;
      }
    }
  }
  return '';
}

function getParamsFromURL() {
  return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
}

// eslint-disable-next-line import/prefer-default-export


/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "A2is":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

/***/ }),

/***/ "GFu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var store = {
  _intent: undefined,
  _intentData: {},
  _recentBrokers: [],
  _isReturningUser: false,
  _deviceType: 'web',
  _isMobileDevice: false,
  origin: '',

  set intent(data) {
    this._intent = data;
  },

  get intent() {
    return this._intent;
  },

  set intentData(data) {
    this._intentData = _extends({}, this._intentData, data);
  },

  get intentData() {
    return this._intentData;
  },

  set recentBrokers(data) {
    this._recentBrokers = data;
  },

  get recentBrokers() {
    return this._recentBrokers;
  },

  set isReturningUser(data) {
    this._isReturningUser = data;
  },

  get isReturningUser() {
    return this._isReturningUser;
  },

  set deviceType(data) {
    this._deviceType = data;
  },

  get deviceType() {
    return this._deviceType;
  },

  set isMobileDevice(data) {
    this._isMobileDevice = data;
  },

  get isMobileDevice() {
    return this._isMobileDevice;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./assets/css/index.css
var css = __webpack_require__("/pBF");
var css_default = /*#__PURE__*/__webpack_require__.n(css);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/query-string/index.js
var query_string = __webpack_require__("/Fvp");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./logic/WindowManager/windowManagerRaw.js + 3 modules
var windowManagerRaw = __webpack_require__("VXI0");

// EXTERNAL MODULE: ./utils/browserUtils.js
var browserUtils = __webpack_require__("pC4Q");

// EXTERNAL MODULE: ./constants/messageTypes.js
var messageTypes = __webpack_require__("hLb+");

// EXTERNAL MODULE: ./utils/store.js
var store = __webpack_require__("GFu3");

// CONCATENATED MODULE: ./logic/WindowManager/windowManager.js





function setupWindowManagerOnMessage() {
  var windowManager = new windowManagerRaw["a" /* default */]();

  function interpretOnMessage(ev) {
    return new Promise(function ($return, $error) {
      var manageWindowArgument, gatewayName;

      if (ev.source === Object(browserUtils["d" /* getParentWindow */])(window)) {
        if (ev.data.type === messageTypes["a" /* default */].MANAGE_WINDOW) {
          manageWindowArgument = ev.data.argument;
          return Promise.resolve(windowManager.open(manageWindowArgument)).then(function ($await_3) {
            try {
              Object(browserUtils["i" /* sendPostMessage */])({
                messageType: messageTypes["a" /* default */].MANAGE_WINDOW_FINISHED,
                messageParams: {}
              });
              return $If_2.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        } else {
          if (ev.data.type === messageTypes["a" /* default */].CLOSE_ALL_WINDOW) {
            windowManager.closeAll();
            Object(browserUtils["i" /* sendPostMessage */])({
              messageType: messageTypes["a" /* default */].CLOSE_ALL_WINDOW_FINISHED,
              messageParams: {}
            });
          } else if (ev.data.type === messageTypes["a" /* default */].UPDATE_GATEWAY_NAME) {
            gatewayName = ev.data.gatewayName;

            store["a" /* default */].origin = ev.origin;
            window.updateGatewayName(gatewayName);
          }
          return $If_2.call(this);
        }
        function $If_2() {
          return $return();
        }
      }
      if (ev.data.type === 'SET_CROSS_SITE_COOKIE') {
        Object(browserUtils["i" /* sendPostMessage */])({
          messageType: messageTypes["a" /* default */].CONNECT_LOADED,
          messageParams: {
            thirdPartyCookieSupported: ev.data.hasAccess
          }
        });
        windowManager._window.primary.close(false);
      }
      if (ev.data.type === messageTypes["a" /* default */].GET_ORIGIN) {
        windowManager.message({ type: messageTypes["a" /* default */].SET_ORIGIN, origin: store["a" /* default */].origin });
      }
      return $return();
    });
  }

  function interpretFromNative(jsonData) {
    var data = JSON.parse(jsonData);
    if (data.type === messageTypes["a" /* default */].MANAGE_WINDOW) {
      var manageWindowArgument = data.argument;

      windowManager.open(manageWindowArgument);
    }
  }

  switch (store["a" /* default */].deviceType) {
    case 'web':
      window.addEventListener('message', interpretOnMessage);
      Object(browserUtils["a" /* check3pCookies */])().then(function (thirdPartyCookieSupported) {
        if (thirdPartyCookieSupported && typeof document.hasStorageAccess === 'function') {
          windowManager.open({
            primaryWindowType: 'iframe',
            primaryURL: 'https://cookie.smallca.se/check3p.html',
            silentIframe: true
          });
        } else {
          Object(browserUtils["i" /* sendPostMessage */])({
            messageType: messageTypes["a" /* default */].CONNECT_LOADED,
            messageParams: {
              thirdPartyCookieSupported: thirdPartyCookieSupported
            }
          });
        }
      });
      break;

    case 'ios':
    case 'android':
      window.postToConnect = interpretFromNative;
      Object(browserUtils["i" /* sendPostMessage */])({ messageType: messageTypes["a" /* default */].CONNECT_LOADED });
      break;
    default:
      break;
  }
}

// eslint-disable-next-line import/prefer-default-export

// CONCATENATED MODULE: ./logic/index.js


function loginInit() {
  setupWindowManagerOnMessage();
}
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/PreBrokerChooser/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("kyER") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var PreBrokerChooser = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/BrokerChooser/index.js

		

		function BrokerChooser_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("L5zP") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var BrokerChooser = (async_default()(BrokerChooser_load));
	
// CONCATENATED MODULE: ./routes/SingleBrokerLogin/index.js

		

		function SingleBrokerLogin_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("qHfq") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var SingleBrokerLogin = (async_default()(SingleBrokerLogin_load));
	
// CONCATENATED MODULE: ./routes/PreConnect/index.js

		

		function PreConnect_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("cEix") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var PreConnect = (async_default()(PreConnect_load));
	
// CONCATENATED MODULE: ./routes/BrokerConnected/index.js

		

		function BrokerConnected_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("bcLm") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var BrokerConnected = (async_default()(BrokerConnected_load));
	
// CONCATENATED MODULE: ./routes/Placeholder/index.js

		

		function Placeholder_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("lYl4") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var Placeholder = (async_default()(Placeholder_load));
	
// CONCATENATED MODULE: ./routes/VerifyingLogin/index.js

		

		function VerifyingLogin_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("TSSm") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var VerifyingLogin = (async_default()(VerifyingLogin_load));
	
// EXTERNAL MODULE: ./components/StaticContainer/StaticContainer.js
var StaticContainer = __webpack_require__("RMlJ");

// EXTERNAL MODULE: ./routes/EmptyBg/index.js
var EmptyBg = __webpack_require__("Vjv/");

// EXTERNAL MODULE: ./utils/brokerUtils.js
var brokerUtils = __webpack_require__("49Lv");

// EXTERNAL MODULE: ./utils/copyConstants.js
var copyConstants = __webpack_require__("JxML");

// EXTERNAL MODULE: ./routes/OrderCancelled/OrderCancelled.css
var OrderCancelled = __webpack_require__("w69u");
var OrderCancelled_default = /*#__PURE__*/__webpack_require__.n(OrderCancelled);

// CONCATENATED MODULE: ./routes/OrderCancelled/OrderCancelled.js

/* eslint-disable no-extra-boolean-cast */










function handleClick(error) {
  if (!!error) {
    Object(browserUtils["i" /* sendPostMessage */])({
      messageType: messageTypes["a" /* default */].USER_CANCELLED
    });
    return;
  }
  Object(browserUtils["i" /* sendPostMessage */])({
    messageType: messageTypes["a" /* default */].RESTART_ORDER
  });
}

var _ref = Object(preact_min["h"])(EmptyBg["a" /* default */], null);

var _ref2 = Object(preact_min["h"])('i', { 'class': 'icon-error' });

function OrderCancelled_OrderCancelled(props) {
  if (props.loading) {
    return _ref;
  }
  var params = Object(brokerUtils["e" /* getParamsFromURL */])();
  var brokerName = Object(brokerUtils["a" /* getBrokerDisplayNameFromURL */])(props.brokerMap);
  var error = params.error,
      smallcase = params.smallcase,
      _params$distributor = params.distributor,
      distributor = _params$distributor === undefined ? 'merchant' : _params$distributor;


  var copy = props.copies['order-cancelled'];
  return Object(preact_min["h"])(
    StaticContainer["a" /* default */],
    { showClose: true },
    Object(preact_min["h"])(
      'div',
      { 'class': 'route-padding' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'route-main-container' },
        Object(preact_min["h"])(
          'div',
          { 'class': OrderCancelled_default.a['top-logo'] },
          _ref2
        ),
        Object(preact_min["h"])(
          'h2',
          { 'class': 'title' },
          copy.title.replace(copyConstants["a" /* brokerRegex */], brokerName).replace(copyConstants["b" /* distributorRegex */], distributor).replace(copyConstants["d" /* smallcaseRegex */], smallcase)
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': OrderCancelled_default.a['desc'] + ' lh-144 text-normal' },
          !!error ? copy.withError.replace(copyConstants["a" /* brokerRegex */], brokerName).replace(copyConstants["b" /* distributorRegex */], distributor).replace(copyConstants["d" /* smallcaseRegex */], smallcase) : copy.withoutError.replace(copyConstants["a" /* brokerRegex */], brokerName).replace(copyConstants["b" /* distributorRegex */], distributor).replace(copyConstants["d" /* smallcaseRegex */], smallcase)
        ),
        Object(preact_min["h"])(
          'button',
          {
            type: 'button',
            'class': 'btn ' + OrderCancelled_default.a['mt16'] + ' ' + OrderCancelled_default.a['retry'],
            onClick: function onClick() {
              return handleClick(error);
            }
          },
          !!error ? 'Go Back' : 'Retry Order'
        )
      )
    )
  );
}

/* harmony default export */ var routes_OrderCancelled_OrderCancelled = (OrderCancelled_OrderCancelled);
// CONCATENATED MODULE: ./routes/LoginFailed/index.js

		

		function LoginFailed_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("J3qU") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var LoginFailed = (async_default()(LoginFailed_load));
	
// CONCATENATED MODULE: ./routes/OrderflowWaiting/index.js

		

		function OrderflowWaiting_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("EsdI") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var OrderflowWaiting = (async_default()(OrderflowWaiting_load));
	
// CONCATENATED MODULE: ./routes/OrderInQueue/index.js

		

		function OrderInQueue_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("kG8x") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var OrderInQueue = (async_default()(OrderInQueue_load));
	
// CONCATENATED MODULE: ./routes/HoldingsFetch/index.js

		

		function HoldingsFetch_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("Pv2C") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var HoldingsFetch = (async_default()(HoldingsFetch_load));
	
// CONCATENATED MODULE: ./routes/SmallcaseLoader/index.js

		

		function SmallcaseLoader_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("KpUf") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var SmallcaseLoader = (async_default()(SmallcaseLoader_load));
	
// CONCATENATED MODULE: ./routes/GenericLoader/index.js

		

		function GenericLoader_load(cb) {
			__webpack_require__.e/* require.ensure */(13).then((function (require) {
				cb( __webpack_require__("7gaL") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var GenericLoader = (async_default()(GenericLoader_load));
	
// CONCATENATED MODULE: ./routes/Error/index.js

		

		function Error_load(cb) {
			__webpack_require__.e/* require.ensure */(14).then((function (require) {
				cb( __webpack_require__("r/jS") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var Error = (async_default()(Error_load));
	
// CONCATENATED MODULE: ./routes/CloseWindow/index.jsx





var selfClose = function selfClose() {
  window.isSelfClosed = true;
  window.close();
};

var CloseWindow__ref = Object(preact_min["h"])(
  StaticContainer["a" /* default */],
  null,
  Object(preact_min["h"])(
    "button",
    { type: "button", "class": "btn btn-primary mt16", onClick: selfClose },
    "Close"
  )
);

function CloseWindow(params) {
  // try closing immediately, if it fails, show a button to close
  selfClose();
  return CloseWindow__ref;
}

/* harmony default export */ var routes_CloseWindow = (CloseWindow);
// CONCATENATED MODULE: ./routes/LasLoader/index.js

		

		function LasLoader_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("m+6h") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var LasLoader = (async_default()(LasLoader_load));
	
// CONCATENATED MODULE: ./components/app.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-multi-comp */






// Code-splitting is automated for routes





















var brokerConfigURL = 'https://config.smallcase.com/brokerconfig/' + "production" + '/brokerConfig.json';

var copyConfigURL = 'https://config.smallcase.com/gateway/copyConfig/' + "production" + '/copyConfig.json';

var app_Redirect = function (_Component) {
  _inherits(Redirect, _Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Redirect.prototype.componentWillMount = function componentWillMount() {
    Object(preact_router_es["b" /* route */])(this.props.to, true);
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(preact_min["Component"]);

var app__ref2 = Object(preact_min["h"])(Placeholder, {
  path: '/waiting'
});

var _ref3 = Object(preact_min["h"])(SmallcaseLoader, {
  path: '/smallcase-loader'
});

var _ref4 = Object(preact_min["h"])(GenericLoader, {
  path: '/loader'
});

var _ref5 = Object(preact_min["h"])(LasLoader, {
  path: '/las-loader'
});

var _ref6 = Object(preact_min["h"])(Error, {
  path: '/error'
});

var _ref7 = Object(preact_min["h"])(routes_CloseWindow, {
  path: '/close'
});

var _ref8 = Object(preact_min["h"])(EmptyBg["a" /* default */], { path: '/empty' });

var _ref9 = Object(preact_min["h"])(app_Redirect, { path: '/', to: '/empty' });

var app_App = function (_Component2) {
  _inherits(App, _Component2);

  function App(props) {
    _classCallCheck(this, App);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this2.state = {
      loading: true,
      gatewayName: 'Merchant'
    };
    if (typeof window !== 'undefined') {
      var params = query_string_default.a.parse(window.location.search);
      _this2.gateway = params.gateway || 'default';
      window.updateGatewayName = function (gatewayName) {
        _this2.setState({
          gatewayName: gatewayName
        });
      };

      if (params.deviceType) store["a" /* default */].deviceType = params.deviceType;
      if (params.deviceType === 'ios' || params.deviceType === 'android') store["a" /* default */].isMobileDevice = true;
    }
    return _this2;
  }

  App.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var noSWPromise = Promise.resolve(true);
    if (window.navigator.serviceWorker) {
      noSWPromise = window.navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var registration = _ref;

          registration.unregister();
        }
      }).catch(function (err) {
        return err;
      });
    }

    noSWPromise.then(function () {
      var fetchBrokerConfig = fetch(brokerConfigURL).then(function (res) {
        return res.json();
      }).then(function (brokers) {
        _this3.brokerMap = brokers;
      });
      var fetchCopy = fetch(copyConfigURL).then(function (res) {
        return res.json();
      }).then(function (copies) {
        _this3.copies = copies;
      });
      Promise.all([fetchBrokerConfig, fetchCopy]).then(function () {
        _this3.setState({
          loading: false
        });
      });
      loginInit();
    });
  };

  /** Gets fired when the route changes.
    * @param {Object} event "change" event from [preact-router](http://git.io/preact-router)
    * @param {string} event.url The newly routed URL
    */


  App.prototype.render = function render() {
    var copy = this.copies && (this.copies[this.gateway] || this.copies['default']);
    return Object(preact_min["h"])(
      'div',
      { id: 'app' },
      Object(preact_min["h"])(
        preact_router_es["a" /* Router */],
        null,
        Object(preact_min["h"])(BrokerChooser, {
          path: '/connect',
          brokerMap: this.brokerMap,
          copies: copy,
          gateway: this.gateway,
          deviceType: this.state.deviceType
        }),
        Object(preact_min["h"])(PreBrokerChooser, {
          path: '/pre-broker-chooser',
          copies: copy
        }),
        Object(preact_min["h"])(PreConnect, {
          path: '/pre-connect',
          brokerMap: this.brokerMap,
          copies: copy,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(BrokerConnected, {
          path: '/post-connect',
          brokerMap: this.brokerMap,
          copies: copy,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(HoldingsFetch, {
          path: '/holding-import',
          brokerMap: this.brokerMap,
          copies: copy,
          loading: this.state.loading
        }),
        app__ref2,
        Object(preact_min["h"])(VerifyingLogin, {
          path: '/verifying-login',
          brokerMap: this.brokerMap,
          copies: copy,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(routes_OrderCancelled_OrderCancelled, {
          path: '/order-cancelled',
          copies: copy,
          brokerMap: this.brokerMap,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(LoginFailed, {
          path: '/login-failed',
          copies: copy,
          brokerMap: this.brokerMap,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(SingleBrokerLogin, {
          path: '/click-to-continue',
          copies: copy,
          brokerMap: this.brokerMap,
          loading: this.state.loading,
          gatewayName: this.state.gatewayName
        }),
        Object(preact_min["h"])(OrderflowWaiting, {
          path: '/orderflow-waiting',
          copies: copy,
          brokerMap: this.brokerMap,
          loading: this.state.loading
        }),
        Object(preact_min["h"])(OrderInQueue, {
          path: '/order-in-queue',
          copies: copy,
          loading: this.state.loading
        }),
        _ref3,
        _ref4,
        _ref5,
        _ref6,
        _ref7,
        _ref8,
        _ref9
      )
    );
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "JxML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brokerRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distributorRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return smallcaseRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return orderDetailsRegex; });
var brokerRegex = /<BROKER>/gi;
var distributorRegex = /<DISTRIBUTOR>/gi;
var smallcaseRegex = /<SMALLCASE>/gi;
var orderDetailsRegex = /<ORDER_DETAILS>/gi;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "Kvx2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"p20":"p20__cQQhj","a20":"a20__1ZRxd","p40":"p40__3VzM0","a40":"a40__1UbGA","p60":"p60__3fWd2","a60":"a60__2usKO","p80":"p80__2h0Uz","a80":"a80__1csQd","p100":"p100__2Ovid","a100":"a100__1rcsg","shape2":"shape2__1V3nV","s1":"s1__1aOlh","mb16":"mb16__2YYFL"};

/***/ }),

/***/ "Lupr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css__ = __webpack_require__("Kvx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css__);

// eslint-disable-next-line no-unused-vars




function ConnectingAnimation(params) {
  var animationSVG = "<svg width=\"145\" height=\"25\" viewBox=\"0 0 145 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <circle cx=\"6.5\" cy=\"12.5\" r=\"1\" fill=\"#CECECE\" stroke=\"#CECECE\"/>\n    <path d=\"M10.5 7.5C13.5 11 13.5 13.5 10.5 17.5\" stroke=\"#81878C\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['shape2'] + "\" d=\"M15 3C20.3333 9.65 20.3333 14.4 15 22\" stroke=\"#535B62\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['p20'] + "\" d=\"M39 12.5H45\" stroke=\"#535B62\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['p40'] + "\" d=\"M54 12.5H60\" stroke=\"#535B62\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['p60'] + "\" d=\"M69 12.5H75\" stroke=\"#535B62\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['p80'] + "\" d=\"M84 12.5H90\" stroke=\"#CECECE\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path class=\"" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a['p100'] + "\" d=\"M99 12.5H105\" stroke=\"#CECECE\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n    <path d=\"M127 7.5L129 7.5\" stroke=\"#535B62\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n    <path d=\"M127 16.5H129\" stroke=\"#535B62\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n    <path d=\"M132 16.5H133\" stroke=\"#81878C\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n    <path d=\"M132 7.5H133\" stroke=\"#81878C\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n    <path d=\"M122.5 12V19C122.5 20.1046 123.395 21 124.5 21H140.5C141.605 21 142.5 20.1046 142.5 19V12M122.5 12V5C122.5 3.89543 123.395 3 124.5 3H140.5C141.605 3 142.5 3.89543 142.5 5V12M122.5 12H142.5\" stroke=\"#CECECE\" stroke-width=\"3\" stroke-linecap=\"round\"/>\n</svg>\n";

  return (
    // eslint-disable-next-line react/no-danger
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", {
      "class": "" + __WEBPACK_IMPORTED_MODULE_1__ConnectingAnimation_css___default.a["mb16"],
      dangerouslySetInnerHTML: { __html: animationSVG }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ConnectingAnimation);

/***/ }),

/***/ "PUCB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"static-container":"static-container__E7LF5","dark-bg":"dark-bg__BQ2UA","close-button-container":"close-button-container__2EKeN text-light","static-container-inner":"static-container-inner__3O-15","shadow":"shadow__2pymF"};

/***/ }),

/***/ "RMlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_browserUtils__ = __webpack_require__("pC4Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_messageTypes__ = __webpack_require__("hLb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css__ = __webpack_require__("PUCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StaticContainer_css__);







function onCloseClick(ev) {
  ev.preventDefault();

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_browserUtils__["i" /* sendPostMessage */])({
    messageType: __WEBPACK_IMPORTED_MODULE_2__constants_messageTypes__["a" /* default */].USER_CANCELLED,
    messageParams: {
      reason: 'CloseButtonClicked'
    }
  });
}

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { 'class': 'icon-close' });

function StaticContainer(props) {
  var showClose = props.showClose,
      hideOverlayBackground = props.hideOverlayBackground;


  if (showClose === undefined) {
    showClose = false;
  }

  if (hideOverlayBackground === undefined) {
    hideOverlayBackground = false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default.a['static-container'] + ' ' + (!hideOverlayBackground ? __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default.a['dark-bg'] : '') },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default.a['static-container-inner'] + ' ' + __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default.a['shadow'] },
      showClose ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { 'class': __WEBPACK_IMPORTED_MODULE_3__StaticContainer_css___default.a['close-button-container'], onClick: onCloseClick },
        _ref
      ) : null,
      props.children
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (StaticContainer);

/***/ }),

/***/ "VXI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./utils/browserUtils.js
var browserUtils = __webpack_require__("pC4Q");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./constants/messageTypes.js
var messageTypes = __webpack_require__("hLb+");

// CONCATENATED MODULE: ./constants/urls.js
// temp: Fix finally to /static or something similar
// root of this url
var statusURLPrefix = '/';


// CONCATENATED MODULE: ./logic/WindowManager/windowListeners.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// FIXME: REMOVE Once changes are made from kite
var KITE_ORIGIN = "https://kite.zerodha.com";

var POPUP_CLOSE_GRACE_MS = 500;

var POSTMESSAGE_ACK = "POSTMESSAGE_ACK";
var POPUP_SELF_CLOSING = "POPUP_SELF_CLOSING";

/**
 * @param {{primaryWindow: PrimaryNewTab, delayMs: number}} param0
 * @returns {{promise: Promise<boolean>, cancel: () => void, intervalID: number}}
 */
function onWindowClosePromise(_ref) {
  var primaryWindow = _ref.primaryWindow,
      _ref$delayMs = _ref.delayMs,
      delayMs = _ref$delayMs === undefined ? 500 : _ref$delayMs;

  var returnObj = {
    promise: undefined,
    cancel: undefined,
    intervalID: undefined,
    graceTimeoutID: undefined
  };

  returnObj.promise = new Promise(function (resolve) {
    returnObj.intervalID = setInterval(function () {
      var windowInstance = primaryWindow.windowInstance;

      if (windowInstance === undefined || !windowInstance.closed) return;

      clearInterval(returnObj.intervalID);

      var isSelfClosed = primaryWindow.expectedSelfClose;
      if (isSelfClosed) {
        resolve(isSelfClosed);
        return;
      }

      // A result announcing self-close can still arrive after the popup is gone,
      // so re-read the marker once the grace window expires.
      returnObj.graceTimeoutID = setTimeout(function () {
        return resolve(primaryWindow.expectedSelfClose);
      }, POPUP_CLOSE_GRACE_MS);
    }, delayMs);
  });

  returnObj.cancel = function () {
    clearInterval(returnObj.intervalID);
    clearTimeout(returnObj.graceTimeoutID);
  };

  return returnObj;
}

/**
 * @param {{primaryWindow: PrimaryNewTab, delayMs: number}} param0
 * @returns {{promise: Promise<void>, cancel: () => void, intervalID: number}}
 */
function onWindowCloseSendMessagePromise(_ref2) {
  var primaryWindow = _ref2.primaryWindow,
      _ref2$delayMs = _ref2.delayMs,
      delayMs = _ref2$delayMs === undefined ? 500 : _ref2$delayMs;

  var promiseObj = onWindowClosePromise({
    primaryWindow: primaryWindow,
    delayMs: delayMs
  });

  promiseObj.promise = promiseObj.promise.then(function (isSelfClosed) {
    // send message only if window was not self closed
    if (!isSelfClosed) {
      Object(browserUtils["i" /* sendPostMessage */])({
        messageType: messageTypes["a" /* default */].CLOSED_WINDOW,
        messageParams: {
          windowType: "newtab"
        }
      });
    }
  });

  return promiseObj;
}

function setupMessageForwarding(WindowManager) {
  function forwardOnMessage(ev) {
    if (ev.data.type !== undefined && ev.source !== Object(browserUtils["d" /* getParentWindow */])()) {
      if (ev.data.type === POSTMESSAGE_ACK) return;

      // The popup announces this the moment it decides to close itself, so it
      // is never forwarded and there is nobody left to acknowledge.
      if (ev.data.type === POPUP_SELF_CLOSING) {
        var primary = WindowManager._instance && WindowManager._instance._window.primary;
        if (primary && primary.windowType === "newtab" && ev.source === primary.windowInstance) {
          primary.expectedSelfClose = true;
        }
        return;
      }

      var meta = ev.data.meta;

      if (ev.source) {
        try {
          var ack = { type: POSTMESSAGE_ACK };
          if (meta && typeof meta === "object") ack.meta = meta;
          ev.source.postMessage(ack, ev.origin);
        } catch (error) {
          // a failed ACK must not discard the business result
        }
      }

      // if event has type and have not originated from parent (allow only from its own children),
      // then forward it to parent
      if (ev.data.type === "GATEWAY_LOGIN") {
        // also save the source of the event, given we have to return the message to source
        window._sourceWindow = ev.source;
      }
      Object(browserUtils["i" /* sendPostMessage */])({
        messageType: ev.data.type,
        messageParams: _extends({}, ev.data)
      });
    }
  }

  window.addEventListener("message", forwardOnMessage);

  return {
    cancel: function cancel() {
      return window.removeEventListener("message", forwardOnMessage);
    }
  };
}

// FIXME: Remove this method when changes from kite are done
function setupKiteHoldingAuthorizationForwarding(iframeWindow) {
  function forwardOnMessage(ev) {
    if (ev.origin === KITE_ORIGIN) {
      iframeWindow.postMessage(ev.data, "*");
    }
  }
  window.addEventListener("message", forwardOnMessage);
}


// EXTERNAL MODULE: ./utils/errorUtils.js
var errorUtils = __webpack_require__("Xi7T");

// CONCATENATED MODULE: ./logic/WindowManager/windowClasses.js
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var DEFAULT_SELECTOR = 'body';

function getRandomInt() {
  // number between 0 and 999999
  return Math.floor(Math.random() * 999999);
}

var windowClasses_PrimaryNewTab = (_temp = _class = function () {
  function PrimaryNewTab(url) {
    _classCallCheck(this, PrimaryNewTab);

    this.windowInstance = window.open(url, PrimaryNewTab.windowName);

    if (!this.windowInstance || this.windowInstance.toString() !== '[object Window]') {
      throw errorUtils["a" /* default */].FAILED_TO_OPEN_WINDOW;
    }

    this.show();
    this.windowType = 'newtab';
    this.expectedSelfClose = false;

    var onWindowClosePromiseObj = onWindowCloseSendMessagePromise({
      primaryWindow: this
    });
    this.cancelWindowClosePromise = onWindowClosePromiseObj.cancel;
  }

  PrimaryNewTab.prototype.isOpen = function isOpen() {
    return this.windowInstance !== undefined && !this.windowInstance.closed;
  };

  // eslint-disable-next-line class-methods-use-this


  PrimaryNewTab.prototype.show = function show() {
    if (this.isOpen()) {
      this.windowInstance.focus();
    }
  };

  // eslint-disable-next-line class-methods-use-this


  PrimaryNewTab.prototype.hide = function hide() {
    window.focus();
  };

  PrimaryNewTab.prototype.changeURL = function changeURL(url) {
    if (url) {
      this.expectedSelfClose = false;
      this.windowInstance.location.replace(url);
    }
    this.show();
  };

  PrimaryNewTab.prototype.close = function close() {
    this.cancelWindowClosePromise();

    this.windowInstance.close();
    this.hide();
    this.windowInstance = undefined;
    this.windowType = undefined;
  };

  PrimaryNewTab.prototype.message = function message(payload) {
    this.windowInstance.postMessage(payload, '*');
  };

  return PrimaryNewTab;
}(), _class.windowName = 'sc-gw-' + getRandomInt(), _temp);

var windowClasses_PrimaryIframe = function () {
  function PrimaryIframe(url) {
    var silentIframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, PrimaryIframe);

    this.referenceElement = Object(browserUtils["b" /* getHtmlElement */])(DEFAULT_SELECTOR);
    this.windowInstance = Object(browserUtils["h" /* prepareIFrame */])(url);
    if (!silentIframe) this.show();
    this.referenceElement.appendChild(this.windowInstance);
    this.windowType = 'iframe';
    setupKiteHoldingAuthorizationForwarding(this.windowInstance.contentWindow);
  }

  PrimaryIframe.prototype.isOpen = function isOpen() {
    return this.windowInstance !== undefined;
  };

  // eslint-disable-next-line class-methods-use-this


  PrimaryIframe.prototype.show = function show() {
    // Ask parent window to show secondary iframe (which contains this primary iframe)
    Object(browserUtils["i" /* sendPostMessage */])({ messageType: messageTypes["a" /* default */].SHOW_FRAME });
  };

  // eslint-disable-next-line class-methods-use-this


  PrimaryIframe.prototype.hide = function hide() {
    // Ask parent window to hide secondary iframe (which contains this primary iframe)
    Object(browserUtils["i" /* sendPostMessage */])({ messageType: messageTypes["a" /* default */].HIDE_FRAME });
  };

  PrimaryIframe.prototype.changeURL = function changeURL(url) {
    this.show();
    this.windowInstance.src = url;
  };

  PrimaryIframe.prototype.close = function close() {
    var shouldHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    shouldHide && this.hide();
    this.referenceElement.removeChild(this.windowInstance);
    this.windowInstance = undefined;
    this.windowType = undefined;
  };

  PrimaryIframe.prototype.message = function message(payload) {
    this.windowInstance.contentWindow.postMessage(payload, '*');
  };

  return PrimaryIframe;
}();

var windowClasses_SecondaryIframe = function () {
  function SecondaryIframe(status) {
    _classCallCheck(this, SecondaryIframe);

    this.windowInstance = window;
    this.windowType = 'iframe';
    this.show();
    this.changeURL(status);
  }

  SecondaryIframe.prototype.isOpen = function isOpen() {
    return this.windowInstance !== undefined;
  };

  // eslint-disable-next-line class-methods-use-this


  SecondaryIframe.prototype.show = function show() {
    // Ask parent window to show self
    Object(browserUtils["i" /* sendPostMessage */])({ messageType: messageTypes["a" /* default */].SHOW_FRAME });
  };

  // eslint-disable-next-line class-methods-use-this


  SecondaryIframe.prototype.hide = function hide() {
    // Move back to empty state
    Object(preact_router_es["b" /* route */])(statusURLPrefix, true);
    // Ask parent window to hide self
    Object(browserUtils["i" /* sendPostMessage */])({ messageType: messageTypes["a" /* default */].HIDE_FRAME });
  };
  // eslint-disable-next-line class-methods-use-this

  SecondaryIframe.prototype.changeURL = function changeURL(status) {
    this.show();
    Object(preact_router_es["b" /* route */])(statusURLPrefix + status, true);
  };

  SecondaryIframe.prototype.close = function close() {
    var shouldHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    shouldHide && this.hide();
    this.windowInstance = undefined;
    this.windowType = undefined;
  };

  return SecondaryIframe;
}();

/* eslint-disable quote-props */
var primaryClassMap = {
  'iframe': windowClasses_PrimaryIframe,
  'newtab': windowClasses_PrimaryNewTab
};
/* eslint-enable quote-props */
// EXTERNAL MODULE: ./utils/clickToContinueUtils.js
var clickToContinueUtils = __webpack_require__("23TE");

// EXTERNAL MODULE: ./utils/store.js
var store = __webpack_require__("GFu3");

// CONCATENATED MODULE: ./logic/WindowManager/windowManagerRaw.js
function windowManagerRaw__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








// eslint-disable-next-line import/prefer-default-export

var windowManagerRaw_WindowManager = function () {
  function WindowManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$elementOrSelecto = _ref.elementOrSelector,
        elementOrSelector = _ref$elementOrSelecto === undefined ? DEFAULT_SELECTOR : _ref$elementOrSelecto;

    windowManagerRaw__classCallCheck(this, WindowManager);

    if (WindowManager._instance !== undefined) {
      return WindowManager._instance;
    }
    WindowManager._instance = this;
    this.referenceElement = Object(browserUtils["b" /* getHtmlElement */])(elementOrSelector);
    this._window = {
      /**
       * @type {PrimaryNewTab | PrimaryIframe | undefined}
       */
      primary: undefined,
      /**
       * @type {SecondaryIframe | undefined}
       */
      secondary: undefined
    };

    setupMessageForwarding(WindowManager);
  }

  WindowManager.openPrimaryNewTabByUserClick = function openPrimaryNewTabByUserClick(_ref2) {
    return new Promise(function ($return, $error) {
      var broker, intent, windowManager;
      broker = _ref2.broker, intent = _ref2.intent;

      // rest global "click to continue" promise
      Object(clickToContinueUtils["b" /* resetClickToContinue */])();

      // redirect to click to continue page
      "production" !== 'production' && console.log('Redirecting to click-to-continue page');

      windowManager = new WindowManager();
      windowManager.open({
        secondaryStatus: 'click-to-continue/?broker=' + broker,
        changeOnly: 'secondary',
        broker: broker,
        intent: intent
      });

      // wait for user click promise to resolve
      return Promise.resolve(clickToContinueUtils["a" /* clickToContinueContainer */].current.promise).then(function ($await_6) {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  WindowManager.prototype.open = function open() {
    var $args = arguments;return new Promise(function ($return, $error) {
      var _this, _arguments, _ref3, _ref3$primaryWindowTy, primaryWindowType, primaryURL, _ref3$secondaryStatus, secondaryStatus, _ref3$broker, broker, _ref3$changeOnly, changeOnly, _ref3$bypassClickToCo, bypassClickToContinue, _ref3$intent, intent, _ref3$intentData, intentData, _ref3$recentBrokers, recentBrokers, _ref3$isReturningUser, isReturningUser, _ref3$silentIframe, silentIframe, expectedWindow, shouldHideIframe, isCurrentPrimaryDefined, isExpectedPrimaryDefined, ClassToUse, _open2, isCurrentSecondaryDefined, isExpectedSecondaryDefined;

      _this = this, _arguments = $args;
      _ref3 = $args.length > 0 && $args[0] !== undefined ? $args[0] : {}, _ref3$primaryWindowTy = _ref3.primaryWindowType, primaryWindowType = _ref3$primaryWindowTy === undefined ? 'newtab' : _ref3$primaryWindowTy, primaryURL = _ref3.primaryURL, _ref3$secondaryStatus = _ref3.secondaryStatus, secondaryStatus = _ref3$secondaryStatus === undefined ? undefined : _ref3$secondaryStatus, _ref3$broker = _ref3.broker, broker = _ref3$broker === undefined ? undefined : _ref3$broker, _ref3$changeOnly = _ref3.changeOnly, changeOnly = _ref3$changeOnly === undefined ? undefined : _ref3$changeOnly, _ref3$bypassClickToCo = _ref3.bypassClickToContinue, bypassClickToContinue = _ref3$bypassClickToCo === undefined ? false : _ref3$bypassClickToCo, _ref3$intent = _ref3.intent, intent = _ref3$intent === undefined ? 'default' : _ref3$intent, _ref3$intentData = _ref3.intentData, intentData = _ref3$intentData === undefined ? {} : _ref3$intentData, _ref3$recentBrokers = _ref3.recentBrokers, recentBrokers = _ref3$recentBrokers === undefined ? [] : _ref3$recentBrokers, _ref3$isReturningUser = _ref3.isReturningUser, isReturningUser = _ref3$isReturningUser === undefined ? false : _ref3$isReturningUser, _ref3$silentIframe = _ref3.silentIframe, silentIframe = _ref3$silentIframe === undefined ? false : _ref3$silentIframe;

      // store variables in global store
      store["a" /* default */].intent = intent;
      store["a" /* default */].intentData = intentData;
      store["a" /* default */].recentBrokers = recentBrokers;
      store["a" /* default */].isReturningUser = isReturningUser;

      // Prepare expected window config
      expectedWindow = {
        primary: {
          windowType: primaryWindowType,
          url: primaryURL
        },
        secondary: {
          windowType: 'iframe',
          status: secondaryStatus
        }
      };

      if (expectedWindow.primary.windowType === 'iframe') {
        expectedWindow.secondary = undefined;
      }
      if (primaryURL === undefined || primaryWindowType === undefined) {
        expectedWindow.primary = undefined;
      }
      if (secondaryStatus === undefined) {
        expectedWindow.secondary = undefined;
      }

      // Primary iframe and secondary screen (also iframe) can't be hidden
      // without hiding the other one.
      // So, hide them only if both are expected to be hidden.
      // If any of them is going to remain open,
      // don't hide/show them separately as that will depend on the order of that call.
      shouldHideIframe = expectedWindow.primary === undefined && expectedWindow.secondary === undefined;

      // Cleanup existing window config
      this.cleanupClosedWindows();

      // eslint-disable-next-line no-lone-blocks

      // Compare this._window (current) and expectedWindow (expected)

      // First, compare primary
      if (changeOnly === undefined || changeOnly === 'primary') {
        isCurrentPrimaryDefined = this._window.primary !== undefined;
        isExpectedPrimaryDefined = expectedWindow.primary !== undefined;
        if (isCurrentPrimaryDefined && isExpectedPrimaryDefined && this._window.primary.windowType === expectedWindow.primary.windowType) {
          // If current and expected window are present and are of same type,
          // reuse it
          this._window.primary.changeURL(expectedWindow.primary.url);
          return $If_3.call(this);
        } else {
          // Current window is different from expected and can't be reused

          // So, close current window - if it is present
          if (isCurrentPrimaryDefined) {
            this._window.primary.close(shouldHideIframe);
          }

          if (isExpectedPrimaryDefined) {
            if (!bypassClickToContinue && expectedWindow.primary.windowType === 'newtab') {
              WindowManager.openPrimaryNewTabByUserClick({ broker: broker, intent: intent })
              // on getting click, cancel this function execution
              // and return the same after a fresh function execution
              .then(function () {
                var _open;

                return (_open = _this.open).call.apply(_open, [_this].concat(Array.prototype.slice.call(_arguments)));
              });
              return $return();
            }

            // And then create new window
            ClassToUse = primaryClassMap[expectedWindow.primary.windowType];

            var $Try_1_Post = function () {
              try {
                return $If_4.call(this);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this);var $Try_1_Catch = function (err) {
              try {
                if (err !== undefined && err.message === errorUtils["a" /* default */].FAILED_TO_OPEN_WINDOW.message) {
                  return Promise.resolve(WindowManager.openPrimaryNewTabByUserClick({ broker: broker, intent: intent })).then(function ($await_7) {
                    try {

                      // on getting click, cancel this function execution
                      // and return the same after a fresh function execution
                      return $return((_open2 = this.open).call.apply(_open2, [this].concat(Array.prototype.slice.call($args))));
                    } catch ($boundEx) {
                      return $error($boundEx);
                    }
                  }.bind(this), $error);
                } else {
                  throw err;
                }
                return $Try_1_Post();
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this);try {
              // try creating new window/iframe
              this._window.primary = new ClassToUse(expectedWindow.primary.url, silentIframe);
              return $Try_1_Post();
            } catch (err) {
              $Try_1_Catch(err)
            }
          }

          function $If_4() {
            return $If_3.call(this);
          }

          return $If_4.call(this);
        }

        function $If_3() {
          return $If_2.call(this);
        }
      }

      // Then, compare secondary

      function $If_2() {
        if (changeOnly === undefined || changeOnly === 'secondary') {
          isCurrentSecondaryDefined = this._window.secondary !== undefined;
          isExpectedSecondaryDefined = expectedWindow.secondary !== undefined;

          // Note: both this._window.secondary and expectedWindow.secondary can be undefined.
          // windowType can be only 'iframe', so it doesn't matter

          if (isCurrentSecondaryDefined && isExpectedSecondaryDefined) {
            // If current and expected windows are not undefined, reuse
            this._window.secondary.changeURL(expectedWindow.secondary.status);
          } else {
            // Either current or expected is undefined, remove and create as needed

            // Close current window - if expected is undefined and current is defined
            if (!isExpectedSecondaryDefined && isCurrentSecondaryDefined) {
              this._window.secondary.close(shouldHideIframe);
              this._window.secondary = undefined;
            }

            // Create window - if current is undefined and expected is defined
            if (!isCurrentSecondaryDefined && isExpectedSecondaryDefined) {
              this._window.secondary = new windowClasses_SecondaryIframe(expectedWindow.secondary.status);
            }
          }
        }


        return $return(undefined);
      }

      return $If_2.call(this);
    }.bind(this));
  };

  WindowManager.prototype.cleanupClosedWindows = function cleanupClosedWindows() {
    if (this._window.primary !== undefined && !this._window.primary.isOpen()) {
      // clear out any active timers
      if (this._window.primary.cancelWindowClosePromise) {
        this._window.primary.cancelWindowClosePromise();
      }
      this._window.primary = undefined;
    }
    // No need to check for secondary one, as it can only be a iframe
  };

  WindowManager.prototype.closeAll = function closeAll() {
    this.cleanupClosedWindows();

    if (this._window.primary !== undefined) {
      this._window.primary.close();
      this._window.primary = undefined;
    }
    if (this._window.secondary !== undefined) {
      // No-op
      this._window.secondary.close();
      this._window.secondary = undefined;
    }
  };

  WindowManager.prototype.message = function message(payload) {
    if (this._window.primary) {
      this._window.primary.message(payload);
    }
  };

  return WindowManager;
}();

/* harmony default export */ var windowManagerRaw = __webpack_exports__["a"] = (windowManagerRaw_WindowManager);

/***/ }),

/***/ "Vjv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(15).then((function (require) {
				cb( __webpack_require__("EHcD") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "Xi7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var errorMap = {
  INVALID_ELEMENTORSELECTOR: new Error('invalid_elementorselector'),
  FAILED_TO_OPEN_WINDOW: new Error('failed_to_open_window')
};

/* harmony default export */ __webpack_exports__["a"] = (errorMap);

/***/ }),

/***/ "hLb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var postMessageTypes = {
  USER_CANCELLED: 'USER_CANCELLED',
  SHOW_FRAME: 'SHOW_FRAME',
  HIDE_FRAME: 'HIDE_FRAME',
  CLOSED_WINDOW: 'CLOSED_WINDOW',
  MANAGE_WINDOW: 'MANAGE_WINDOW',
  MANAGE_WINDOW_FINISHED: 'MANAGE_WINDOW_FINISHED',
  CLOSE_ALL_WINDOW: 'CLOSE_ALL_WINDOW',
  CLOSE_ALL_WINDOW_FINISHED: 'CLOSE_ALL_WINDOW_FINISHED',
  LOGIN_BUTTON_CLICKED: 'LOGIN_BUTTON_CLICKED',
  RESTART_ORDER: 'RESTART_ORDER',
  CONNECT_LOADED: 'CONNECT_LOADED',
  BROKER_TWEET: 'BROKER_TWEET',
  USER_SIGNUP: 'USER_SIGNUP',
  LOGIN_BUTTON_CLICKED_CONSENT_REQUIRED: 'LOGIN_BUTTON_CLICKED_CONSENT_REQUIRED',
  HOLDINGS_IMPORT_ACCOUNT_AGGREGATOR: 'HOLDINGS_IMPORT_ACCOUNT_AGGREGATOR',
  UPDATE_GATEWAY_NAME: 'UPDATE_GATEWAY_NAME',
  GET_ORIGIN: 'GET_ORIGIN',
  SET_ORIGIN: 'SET_ORIGIN'
};

/* harmony default export */ __webpack_exports__["a"] = (postMessageTypes);

/***/ }),

/***/ "pC4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getParentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return prepareIFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHtmlElement; });
/* unused harmony export listenMessageEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendPostMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTimeLeftFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getReasonFromURL; });
/* unused harmony export getBrokerUserIDFromURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return check3pCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMobileContext; });
/* unused harmony export getInnerHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTouchDirection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("/Fvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorUtils__ = __webpack_require__("Xi7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("GFu3");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Returns Parent window of the current page.
 *
 * @param {Window} currentWindow
 * @returns {Window}
 */
function getParentWindow() {
  var currentWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  return currentWindow.parent;
}

/**
 * Returns a customized IFrame element which loads connect.smallcase.com
 *
 * **This DOESN'T append the element to DOM**
 *
 * @returns {HTMLIFrameElement}
 */
function prepareIFrame(url) {
  var iframeElement = document.createElement('iframe');
  iframeElement.setAttribute('src', url);
  iframeElement.setAttribute('sandbox', 'allow-scripts allow-forms allow-popups allow-same-origin allow-top-navigation-by-user-activation');
  iframeElement.style.position = 'fixed';
  iframeElement.style.top = '50%';
  iframeElement.style.left = '50%';
  iframeElement.style.transform = 'translate(-50%, -50%)';
  iframeElement.style.width = '100vw';
  iframeElement.style.height = '100vh';
  iframeElement.style.minHeight = '360px';
  iframeElement.style.borderWidth = '0';
  iframeElement.style.zIndex = '+2147483647'; // safe highest allowed value
  // iframeElement.style.backgroundColor = 'white';
  // iframeElement.style.boxShadow = '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
  return iframeElement;
}

/**
 * Get HTMLElement from elementOrSelector, which can be a selector or an actual HTMLElement.
 *
 * @param {string | HTMLElement} elementOrSelector
 * @returns {HTMLElement}
 */
function getHtmlElement(elementOrSelector) {
  if (typeof elementOrSelector === 'string') {
    var element = document.querySelector(elementOrSelector);

    if (!(element instanceof HTMLElement)) {
      throw __WEBPACK_IMPORTED_MODULE_1__errorUtils__["a" /* default */].INVALID_ELEMENTORSELECTOR;
    }

    return element;
  } else {
    var _element = elementOrSelector;

    if (!(_element instanceof HTMLElement)) {
      throw __WEBPACK_IMPORTED_MODULE_1__errorUtils__["a" /* default */].INVALID_ELEMENTORSELECTOR;
    }

    if (_element === null) {
      throw __WEBPACK_IMPORTED_MODULE_1__errorUtils__["a" /* default */].INVALID_ELEMENTORSELECTOR;
    }
    return _element;
  }
}

/**
 * @returns {{promise: Promise<MessageEvent>, cancel: () => void}}
 */
function listenMessageEvent(messageType) {
  var returnObj = {
    promise: undefined,
    cancel: undefined
  };

  returnObj.promise = new Promise(function (resolve) {
    var modifiedResolve = function modifiedResolve(ev) {
      if (ev.data.type && ev.data.type.toLowerCase() === messageType.toLowerCase()) {
        resolve(ev);
      }
    };

    returnObj.cancel = function () {
      window.removeEventListener('message', modifiedResolve);
    };

    window.addEventListener('message', modifiedResolve);
  });

  return returnObj;
}

function sendPostMessage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      messageType = _ref.messageType,
      _ref$messageParams = _ref.messageParams,
      messageParams = _ref$messageParams === undefined ? {} : _ref$messageParams;

  switch (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].deviceType) {
    case 'ios':
      try {
        window.webkit.messageHandlers.postToNativeSdk.postMessage(JSON.stringify(_extends({ type: messageType }, messageParams)));
      } catch (e) {
        console.log('IOS bridge method not found');
      }
      break;

    case 'android':
      try {
        window.AndroidBridge.postToNativeSdk(JSON.stringify(_extends({ type: messageType }, messageParams)));
      } catch (e) {
        console.log('Android bridge method not found');
      }
      break;

    case 'web':
    default:
      /* eslint-disable no-case-declarations */
      var topWindow = getParentWindow();
      var messageObj = _extends({
        type: messageType
      }, messageParams);
      /* eslint-enable no-case-declarations */

      "production" !== 'production' && console.log('middleframe - Trying to send PostMessage: ' + JSON.stringify(messageObj, null, 2));

      if (topWindow !== window) {
        topWindow.postMessage(messageObj, '*');
      }
      break;
  }
}

function getTimeLeftFromURL() {
  var queryParamsObj = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  var timeLeft = queryParamsObj.t;


  return timeLeft;
}

function getReasonFromURL() {
  var queryParamsObj = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  var reason = queryParamsObj.reason;


  return reason;
}

function getBrokerUserIDFromURL() {
  var queryParamsObj = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  var brokerUserID = queryParamsObj.brokerUserID;

  return brokerUserID;
}

function check3pCookies() {
  return new Promise(function ($return, $error) {
    var support;
    return Promise.resolve(new Promise(function ($return, $error) {
      var $logicalAnd_3;if ($logicalAnd_3 = navigator.brave) {
        return Promise.resolve(navigator.brave.isBrave()).then(function ($await_5) {
          try {
            $logicalAnd_3 = $await_5;return $If_4.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_4() {
        return $return($logicalAnd_3);
      }

      return $If_4.call(this);
    })).then(function ($await_6) {
      try {
        if ($await_6) return $return(false);
        document.cookie = 'checkthirdparty=yes; Max-Age=3600; SameSite=None; Secure';
        support = /checkthirdparty=yes/.test(document.cookie);
        document.cookie = 'checkthirdparty=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        return $return(support);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}

function getMobileContext() {
  var width = document.documentElement.clientWidth;
  return {
    desktop: width >= 1184,
    tabletOrLower: width <= 1183,
    tablet: width <= 1183 && width > 768,
    mobile: width <= 768 && width >= 360,
    smaller: width <= 359,
    mobileOnly: width < 768
  };
}

function getInnerHeight() {
  return window.innerHeight;
}

// source: tickertape-web
function getTouchDirection(touchStart, currentTouch) {
  var delta = {
    x: currentTouch.pageX - touchStart.pageX,
    y: -1 * (currentTouch.pageY - touchStart.pageY)
  };

  var perctChange = {
    x: delta.x / touchStart.pageX * 100,
    y: delta.y / touchStart.pageY * 100
  };

  var slope = delta.x !== 0 ? delta.y / delta.x : Math.sign(delta.y) * 10000;

  var touchDirection = {
    delta: delta,
    slope: slope,
    perctChange: perctChange
  };

  if (Math.abs(slope) > 5) {
    touchDirection.orientation = 'VERTICAL';
    if (Math.sign(delta.y) > 0) {
      touchDirection.direction = 'UP';
    } else {
      touchDirection.direction = 'DOWN';
    }
  } else if (Math.abs(slope) < 0.2) {
    touchDirection.orientation = 'HORIZONTAL';
    if (Math.sign(delta.x) < 0) {
      touchDirection.direction = 'LEFT';
    } else {
      touchDirection.direction = 'RIGHT';
    }
  }

  return touchDirection;
}



/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "w69u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"top-logo":"top-logo__UhJfu","mt16":"mt16__zxJgf","retry":"retry__2l5Ya"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.33cba.js